/** Choose white text when it contrasts more strongly with the banner color. */
export function isDarkBannerColor(color: string | null): boolean {
  if (!color || !/^#[0-9a-f]{6}$/i.test(color)) return false;
  const channels = [1, 3, 5].map((index) => {
    const value = parseInt(color.slice(index, index + 2), 16) / 255;
    return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
  });
  const [red = 0, green = 0, blue = 0] = channels;
  return red * 0.2126 + green * 0.7152 + blue * 0.0722 < 0.179;
}
